import styled from 'styled-components';
import { Link, NavLink } from 'react-router-dom';

import { scrollbarStyles } from '@web/components/ScrollableContainer/ScrollableContainer';

// Header outer/absolute height
// height (line-height) + vertical paddings + vertical margins + vertical borders
const headerHeight = '39px';
type WrapperProps = {
  isActive: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  flex-flow: column nowrap;
  flex: 1 1 0px;
  max-height: calc(var(--listContentHeight) + ${headerHeight});
  overflow: hidden;
  opacity: ${({ isActive }) => (isActive ? 1 : 0.5)};
`;

const GROUP_SIZE_HELPER = 18;
export const Header = styled.h3`
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.separatorOnGray};
  color: ${({ theme }) => theme.colors.primaryText};
  display: flex;
  font-size: 12px;
  font-weight: 600;
  justify-content: space-between;
  line-height: ${GROUP_SIZE_HELPER}px;
  margin: 0 20px 10px 0;
  padding: 0 0 10px 0;
`;

export const PlusButton = styled(Link)`
  all: unset;
  align-items: center;
  border: 2px solid currentColor;
  border-radius: 1px;
  box-sizing: border-box;
  color: ${({ theme }) => theme.colors.iconGray};
  cursor: pointer;
  display: flex;
  height: ${GROUP_SIZE_HELPER}px;
  justify-content: center;
  opacity: 0.65;
  padding: 0;
  position: relative;
  text-align: center;
  transition: all 0.125s ease;
  width: ${GROUP_SIZE_HELPER}px;

  &:hover {
    color: ${({ theme }) => theme.colors.iconGray};
    opacity: 1;
    text-decoration: none;
  }
`;

type ListProps = { shouldApplyFallback?: boolean };
export const List = styled.ol<ListProps>`
  list-style: none;
  margin: 0 3px 0 0;
  padding: 0;
  padding-right: ${({ shouldApplyFallback }) => (shouldApplyFallback ? '11px' : '0px')};

  ${scrollbarStyles}
`;

type PinButtonProps = {
  isPinned: boolean;
};
export const PinButton = styled.button<PinButtonProps>`
  all: unset;
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 20px;
  justify-content: center;
  margin-top: 5px;
  width: 20px;

  &:hover {
    color: ${({ theme }) => `${theme.colors.primary}`};
  }

  & > svg {
    transform: ${({ isPinned }) => `rotate(${isPinned ? 0 : 45}deg)`};
  }
`;

type ItemProps = {
  isPinned?: boolean;
  isSilenced?: boolean;
};
export const Item = styled.li<ItemProps>`
  background-color: transparent;
  border-radius: 4px;
  color: ${({ theme }) => theme.colors.iconGray};
  display: flex;
  flex-flow: row nowrap;
  gap: 5px;
  line-height: 20px;
  opacity: ${({ isSilenced }) => (isSilenced ? 0.5 : 1)};
  padding-right: 5px;
  transition: background-color 0.125s ease;

  ${PinButton} {
    opacity: ${({ isPinned }) => +isPinned};
    transition: all 0.125s ease;
  }

  &:hover {
    background-color: ${({ theme }) => `${theme.colors.primary}0c`}; // 5% alpha
    opacity: 1;
  }

  &:hover ${PinButton} {
    opacity: 1;
  }
`;

export const ItemLink = styled(NavLink)`
  color: ${({ theme }) => theme.colors.gray};
  flex: 1;
  font-size: 12px;
  font-weight: 400;
  min-width: 0;
  overflow: hidden;
  padding: 5px 5px 5px 10px;
  text-overflow: ellipsis;
  transition: color 0.25s ease;
  white-space: nowrap;

  &:is(:hover, .active) {
    // NavLink default active class name
    color: ${({ theme }) => theme.colors.primary};
    font-weight: 600;
    text-decoration: none;
  }
`;

export const CounterBadge = styled.div`
  background-color: ${({ theme }) => theme.colors.primary};
  border-radius: 2px;
  color: ${({ theme }) => theme.colors.white};
  font-size: 11px;
  font-weight: 600;
  height: 18px;
  margin-top: 5px;
  min-width: 18px;
  padding: 0 2px;
  line-height: 18px;
  text-align: center;
`;
